import { createStore, applyMiddleware, compose } from 'redux'
import { reactReduxFirebase } from 'react-redux-firebase'
import { reduxFirestore } from 'redux-firestore'
import { routerMiddleware } from 'react-router-redux'
import {createLogger} from 'redux-logger'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import {persistStore} from 'redux-persist'
import rootReducer from './reducers'

import firebase from '../firebase'

export const history = createHistory();

const logger = createLogger({
    collapsed: false,
    logger: console,
    level: {
        prevState: 'debug',
        action: 'debug',
        nextState: 'debug',
        error: 'error'
    }
});

export const reduxFirebaseConfig = {
    presence: 'presence',
    sessions: 'sessions',
    enableLogging: false,

    userProfile: 'users',
    useFirestoreForProfile: true,
};

const initialState = {};
const enhancers = [
    reactReduxFirebase(firebase, reduxFirebaseConfig),
    reduxFirestore(firebase)
];
const middleware = [
    thunk,
    routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.devToolsExtension;

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }

    middleware.push(logger);
}

const composedEnhancers = compose(
    ...enhancers,
    applyMiddleware(...middleware)
);

const store = createStore(
    rootReducer,
    initialState,
    composedEnhancers
);

export const persistor = persistStore(store);
export default store


// WEBPACK FOOTER //
// ./src/redux/store.js